import { ADMIN_ROUTE_PATH, POS_ROUTE_PATH } from '../constants/bookingConst';

/**
 * Whether a pathname is one of the given routes or sits under one.
 *
 * @param {string} pathname - e.g. window.location.pathname
 * @param {string[]} routes - route roots such as '/pos'
 * @returns {boolean}
 */
export const isUnderRoute = (pathname = '', routes = []) => routes
  .some(route => pathname === route || pathname.startsWith(`${route}/`));

/**
 * Whether a pathname belongs to a staff-only screen (the admin dashboard or
 * the Point of Sale) rather than a guest-facing one.
 *
 * Used by screens that would otherwise send the visitor into the guest
 * booking flow — a staff member whose dashboard failed to load wants that
 * dashboard back, not the public time-slot grid.
 *
 * @param {string} pathname - e.g. window.location.pathname
 * @returns {boolean}
 */
export const isStaffRoute = (pathname = '') => isUnderRoute(pathname, [ADMIN_ROUTE_PATH, POS_ROUTE_PATH]);
